export const colorsData = [
    { id: '1', color: 'Red' },
    { id: '2', color: 'White' },
    { id: '3', color: 'Brown' },
    { id: '4', color: 'Black' },
    { id: '5', color: 'Blue' },
    { id: '6', color: 'Grey' },
    { id: '7', color: 'Dark Blue' },
    { id: '8', color: 'Orange' },
    { id: '9', color: 'Green' },
    { id: '10', color: 'Yellow' },
    { id: '11', color: 'Purple' },
    { id: '12', color: 'Pink' },
    { id: '13', color: 'Violet' },
    { id: '14', color: 'Magenta' },
    { id: '15', color: 'Cyan' },
    { id: '16', color: 'Turquoise' },
    { id: '17', color: 'Beige' },
    { id: '18', color: 'Maroon' },
    { id: '19', color: 'Navy' },
    { id: '20', color: 'Teal' },
    { id: '21', color: 'Lime' },
    { id: '22', color: 'Gold' },
    { id: '23', color: 'Silver' },
    { id: '24', color: 'Bronze' },
    { id: '25', color: 'Ivory' },
    { id: '26', color: 'Coral' },
    { id: '27', color: 'Peach' },
    { id: '28', color: 'Olive' },
    { id: '29', color: 'Mint' },
    { id: '30', color: 'Lavender' },
    { id: '31', color: 'Charcoal' },
    { id: '32', color: 'Tan' },
    { id: '33', color: 'Burgundy' },
    { id: '34', color: 'Mustard' },
    { id: '35', color: 'Copper' },
    { id: '36', color: 'Indigo' },
    { id: '37', color: 'Plum' },
    { id: '38', color: 'Sand' },
    { id: '39', color: 'Rust' },
    { id: '40', color: 'Other' }
];